const TEST = false;

const BASE_URL = TEST ? 'http://127.0.0.1:8000' : 'https://avgpokecollector.com';

const CURRENCY_CODE = 'aud';

export {BASE_URL, CURRENCY_CODE};
